import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { AppConfigService } from "src/modules/shared/services/app-config.service";
import { LoaderService } from "src/modules/shared/services/loader.service";
import { NavigationExtras, Router } from "@angular/router";
import { ApplicantManagementService } from "src/modules/profile-management/services/applicant-management-service.service";
import { catchError, map } from "rxjs/operators";
import { error } from "@angular/compiler/src/util";
import { IGetOperationResponse, IOperationResponse } from "../../shared/interfaces/IGetOperationResponse";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: "my-auth-token"
  })
};

const httpUserOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
  withCredentials: true,
  observe: "response" as "response"
};

@Injectable({
  providedIn: "root"
})
export class EmailLoginService {
  public baseUrl: string;
  public authUrl: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private appConfig: AppConfigService
  ) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl + "/api";
    this.authUrl = `${this.baseUrl}/auth`;
  }

  EmailLogin(credentials) {
    return this.http
      .post<any>(
        this.baseUrl + "/auth/login",
        credentials
      )
      .pipe
      // catchError(this.handleError('',))
      (catchError(error => {
        debugger;
        return throwError(error)
      }));
  }

  SendActivationEmail(userEmail: string) {
    return this.http.post<IOperationResponse>(`${this.authUrl}/SendActivationEmail?userEmail=${userEmail}`,
      {});
  }

  SendVerificationEmail(userEmail: string) {
    return this.http.post<IOperationResponse>(`${this.authUrl}/SendVerificationEmail?userEmail=${userEmail}`,
      {});
  }
  CheckCRnumber(crNumber: string) {
    return this.http
      .get<any>(this.baseUrl + "/auth/CheckCRNumber?crNumber=" + crNumber)
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  GetIsEKeyTwo(): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}/eKeyAuth/GetIsEKeyTwo?isEKeyTwo=IsEKey2`);
  }

  GetIsEKey(): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}/eKeyAuth/GetIsEKey?isEKey=IsEKey`);
  }

  GetIsProduction(): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl}/eKeyAuth/GetIsProduction?isProduction=IsProduction`);
  }

  /*
   GetIsEKey(){
    return this.http
    .get<any>(this.baseUrl  + "/eKeyAuth/GetIsEKey?isEKey=" + "IsEKey")
    .pipe();
  }*/

  GetUserById(Id: string) {
    return this.http
      .get<object>(this.baseUrl + "/auth/login")
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  DecodeToken(token: string) {
    return this.http
      .get<any>(this.baseUrl + "/auth/decodeToken?token=" + token)
      .pipe
      // catchError(this.handleError('',))
      ();
  }
  post(object: any, controllerName: string, action: string): Observable<any> {
    return this.http
      .post<object>(
        this.baseUrl + "/" + controllerName + "/" + action,
        object,
        { responseType: "json" }
      )
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  GetApplicantInfoById(object: any): Observable<any> {
    return this.http
      .post<object>(
        this.baseUrl + "/auth/GetApplicantInfoById",
        object
      )
      .pipe
      // catchError(this.handleError('',))
      ();
  }



  GetRelatedCompany(object: any): Observable<any> {
    return this.http
      .post<object>(
        this.baseUrl + "/auth/GetRelatedCompany",
        object,
        httpUserOptions
      )
      .pipe
      // catchError(this.handleError('',))
      ();
  }



  RedirectToLogin() {
    this.router.navigate(["login/redirect"]);
  }

  RegisterToLogin() {
    let registerURL = this.appConfig.getAppConfig().RegisterURL;
    document.location.href = registerURL;
  }


  CreateCompany(object) {
    return this.http
      .post<object>(
        this.baseUrl + "/auth/saveCompany",
        object
      )
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  ResetPassword(user: any): Observable<any> {
    return this.http.post<IGetOperationResponse<any>>(`${this.authUrl}/resetPassword`, user);
  }
}
